import { EMAILS_ACESSO_FORNECEDOR_BASE, EPermissoes } from '@/enums/ePermissoes';
import utlTipoFornecimentoService from '@/services/utilidade/utl-tipo-fornecimento.service';

export default [
  {
    description: 'Fornecedor',
    path: 'fornecedor',
    name: 'fornecedor',
    component: () => import('@/views/gestao/fornecedor/Index.vue'),
    meta: {
      emailsPermitidos: EMAILS_ACESSO_FORNECEDOR_BASE,
      grupos: [],
      escopoObra: 'global'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão Fornecedor',
    path: 'fornecedor/incluir',
    parent: 'fornecedor',
    name: 'fornecedorinsert',
    component: () => import('@/views/gestao/fornecedor/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'fornecedor',
      emailsPermitidos: EMAILS_ACESSO_FORNECEDOR_BASE,
      grupos: []
    }
  },
  {
    description: 'Edição de Fornecedor',
    path: 'fornecedor/editar/:id',
    parent: 'fornecedor',
    name: 'fornecedorupdate',
    component: () => import('@/views/gestao/fornecedor/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'fornecedor',
      emailsPermitidos: EMAILS_ACESSO_FORNECEDOR_BASE,
      grupos: []
    }
  },
  {
    description: 'Fornecedor da Obra',
    path: 'fornecedor-obra',
    name: 'fornecedorobra',
    component: () => import('@/views/gestao/fornecedor-obra/Index.vue'),
    meta: {
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Fornecedor Obra',
    path: 'fornecedor-obra/incluir/:utlTipoFornecimentoId',
    parent: 'fornecedorobra',
    name: 'fornecedorobrainsert',
    component: () => import('@/views/gestao/fornecedor-obra/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'fornecedorobra',
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Fornecedor Obra',
    path: 'fornecedor-obra/editar/:id/:utlTipoFornecimentoId',
    parent: 'fornecedorobra',
    name: 'fornecedorobraupdate',
    component: () => import('@/views/gestao/fornecedor-obra/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'fornecedorobra',
      permissions: [EPermissoes.CadastroObra],
      grupos: []
    }
  },

  {
    description: 'Contatos de Fornecedor da Obra',
    path: 'fornecedor-obra/contatos/:utlTipoFornecimentoId/:id',
    name: 'contatosfornecedorobra',
    component: () => import('@/views/gestao/fornecedor-obra/components/GridContatos.vue'),
    meta: {
      parentRouteName: 'fornecedorobra',
      permissions: [EPermissoes.CadastroObra],
      escopoObra: 'obra'
    },
    goesToMenu: false
  },
  {
    description: 'Inclusão de Contato de Fornecedor Obra',
    path: 'fornecedor-obra/contatos/incluir/:utlTipoFornecimentoId/:id',
    parent: 'contatosfornecedorobra',
    name: 'contatofornecedorobrainsert',
    component: () => import('@/views/gestao/fornecedor-obra/InclusaoEdicaoContatosFornecedor.vue'),
    meta: {
      parentRouteName: 'fornecedorobra',
      campos: () => utlTipoFornecimentoService.getCamposFornecedorObra(301),
      permissions: [EPermissoes.CadastroObra]
    }
  },
  {
    description: 'Edição de Contato de Fornecedor Obra',
    path: 'fornecedor-obra/contatos/editar/:utlTipoFornecimentoId/:gesContatoId',
    parent: 'contatosfornecedorobra',
    name: 'contatosfornecedorobraupdate',
    component: () => import('@/views/gestao/fornecedor-obra/InclusaoEdicaoContatosFornecedor.vue'),
    meta: {
      parentRouteName: 'fornecedorobra',
      permissions: [EPermissoes.CadastroObra],
      grupos: []
    }
  }
];
